import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AutoGroupDropdown } from '../../../../../../models/group-settings';
import { ErrorTemplate, ValidationError } from '../../../../../../models/ErrorTemplate';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../../services/user.service';
import { EventTrackerService, UserActionType, Page, ActivePages } from '../../../../../services/event-tracker/event-tracker.service';
import { ReferenceDataService } from '../../../../../services/reference-data/reference-data.service';
import { CommonConstant } from '../../../../../app.constants';
import { AutoGroupSourceEnum, AutoGroupSource, AutoGroupSourceValue } from '../../../../../../models/auto-group/auto-group-setting';
import { CampaignService } from '../../../../../services/campaign/campaign.service';
import {BrandedSignUp} from '../../../../../../models/auto-group/branded-sign-up';
import { ValidationHandlerService } from '../../../../../core/validation-handler.service';

@Component({
  selector: 'auto-group-source-item',
  templateUrl: './auto-group-source-item.component.html',
  styleUrls: ['./auto-group-source-item.component.scss']
})
export class AutoGroupSourceItemComponent implements OnInit, OnChanges {

  readonly AutoGroupSourceHasValues = [AutoGroupSourceEnum.TOPICS, AutoGroupSourceEnum.INDUSTRIES, AutoGroupSourceEnum.CAMPAIGNS, AutoGroupSourceEnum.LOOKALIKE];
  readonly instagramErrorMsg = 'Missing value';
  readonly otherOption = 'Other';
  readonly AutoGroupSourceHasSingleValue = [AutoGroupSourceEnum.MENTIONS, AutoGroupSourceEnum.LOOKALIKE];

  @Input() availableAutoGroupSourceList: Array<AutoGroupDropdown> = [];
  @Input() listProject: any  = [];
  @Input() itemIndex: number;
  @Input() campaignList: Array<AutoGroupDropdown> = [];
  @Input() influencerGroupList: Array<AutoGroupDropdown> = [];
  @Input() sourceItem: AutoGroupSource;
  @Input() influencerGroupId: number;
  @Input() brandedSignUpConfig: BrandedSignUp;

  @Output() deleteGroupSourceEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() editOrCreateProjectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeGroupSourceEvent: EventEmitter<any> = new EventEmitter<any>();

  public selectedSources: number;
  selectedProject: number;
  hasSelectedSource: boolean;
  hasSelectedInstagramFollower: boolean | false;
  errorMessage: string;
  sourceValueList: Array<AutoGroupDropdown> = [];
  staticComparison: string;
  showStaticValue = false;
  autoGroupSourceValue;
  showValueDropdownList = false;
  showInstagramFollower = false;
  showProjectList = false;
  valueDropdownPlaceholder: string;
  instagramFollwerValue: string;
  sourceStaticValue: string;
  showBrandedSignUp = false;
  noAvailabelCampaign = false;
  private fieldErrors: ErrorTemplate[] = [];
  private mappedSourceValues: Array<AutoGroupSourceValue> = [];

  constructor(private translate: TranslateService,
              private userService: UserService,
              private eventTracker: EventTrackerService,
              private referenceDataService: ReferenceDataService,
              private campaignService: CampaignService) { }

  ngOnInit() {
    this.autoGroupSourceValue = this.sourceItem && this.sourceItem.type && this.AutoGroupSourceHasSingleValue.indexOf(this.sourceItem.type) >= 0 ? null : [];
    if (this.sourceItem && this.sourceItem.type && this.sourceItem.sourceValues.length > 0) {
      this.mappingSourceItemData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sourceItem) {
        this.mappingSourceItemData();
    }
    if (changes.listProject) {
      this.updateProjectList(changes.listProject.currentValue);
    }
  }

  mappingSourceItemData() {
    if (this.sourceItem && this.sourceItem.type) {
      this.selectedSources = this.sourceItem.type;
      this.selectSourceType({id: this.sourceItem.type}, false);
      if (this.AutoGroupSourceHasValues.indexOf(this.sourceItem.type) >= 0) {
        this.mappingAutoGroupSourceValue();
      }
      if (this.sourceItem.type === AutoGroupSourceEnum.MENTIONS) {
        this.selectedProject = this.sourceItem.sourceValues[0].id;
        this.reloadProjectList();
      }
      if (this.sourceItem.type === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
        this.instagramFollwerValue = this.sourceItem.sourceValues[0].name;
      }
      if (this.sourceItem.type === AutoGroupSourceEnum.BRANDED_SIGNUP && this.brandedSignUpConfig) {
        this.showBrandedSignUp = true;
        this.showStaticValue = true;
        this.sourceStaticValue = this.brandedSignUpConfig.brandName;
        this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.from');
      }
    }
  }

  private mappingAutoGroupSourceValue() {
    if (this.sourceItem.type === AutoGroupSourceEnum.LOOKALIKE) {
      this.autoGroupSourceValue = this.sourceItem.sourceValues[0].id;
    } else {
      this.autoGroupSourceValue = this.sourceItem.sourceValues.map(item => {
        return item.id;
      });
    }
  }

  private reloadProjectList() {
    let mappedProjectList = this.listProject.filter(item => item.id === this.sourceItem.sourceValues[0].id);
    const createProjectItem = [
      {
        id: 0,
        name: this.translate.instant('measure.create_new_project')
      }
    ];
    mappedProjectList = mappedProjectList.concat(createProjectItem);
    mappedProjectList = mappedProjectList.concat(this.listProject.filter(listItem => mappedProjectList.every(item => item.id !== listItem.id && listItem !== 0)));
    this.listProject = mappedProjectList;
  }

  selectSourceType(evt, needToRecalculateSourceTypeOption = true) {
    this.fieldErrors = [];
    this.errorMessage = null;
    this.hasSelectedSource = evt ? true : false;
    this.showValueDropdownList = evt && evt.id && this.AutoGroupSourceHasValues.indexOf(evt.id) >= 0;
    this.showStaticValue = false;
    this.showInstagramFollower = false;
    this.showProjectList = false;
    this.autoGroupSourceValue = evt && evt.id && this.AutoGroupSourceHasSingleValue.indexOf(evt.id) >= 0 ? null : [];
    this.selectedProject = null;
    this.noAvailabelCampaign = false;
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.TOPICS) {
      this.loadTopicListAndComparison();
    }
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.INDUSTRIES) {
      this.loadIndustriesListAndComparison();
    }
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.CAMPAIGNS) {
      this.loadCampaignListAndComparison();
    }
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.MENTIONS) {
      this.showProjectList = true;
      if (!this.listProject || this.listProject.length === 0) {
        this.updateProjectList(this.listProject);
        this.userService.getAllProjectOfAdvertiser().subscribe((res: any) => {
          this.listProject = res ? res.data : [];
          this.updateProjectList(this.listProject);
        });
      } else {
        this.updateProjectList(this.listProject);
      }
      this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
    }
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
      this.showInstagramFollower = true;
      this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.from');
    }
    if (evt && evt.id && evt.id === AutoGroupSourceEnum.LOOKALIKE) {
      this.loadInfluencerGroupListAndComparison();
    }
    if (needToRecalculateSourceTypeOption) {
      this.changeGroupSourceEvent.emit(this.sourceItem);
    }
  }

  private loadTopicListAndComparison() {
    const activeTopicList = this.referenceDataService.activeTopics.filter(item => item.name !== this.otherOption);
    this.sourceValueList = activeTopicList.map(item => ({
      id: item.id,
      name: item.name,
      value: item.name
    }));
    this.valueDropdownPlaceholder = this.translate.instant('discover.search_bar.topic_placeholder');
    this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
  }

  private loadIndustriesListAndComparison() {
    const industriesList = this.referenceDataService.verticals.filter(item => item.name !== this.otherOption);
    this.sourceValueList = industriesList.map(item => ({
      id: item.id,
      name: item.name,
      value: item.name
    }));
    this.valueDropdownPlaceholder = this.translate.instant('discover.search_bar.industry_placeholder');
    this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
  }

  private loadInfluencerGroupListAndComparison() {
    const activeGroup = this.influencerGroupList.find(listItem => listItem.id === this.influencerGroupId);
    const otherGroups = this.influencerGroupList.filter(listItem => listItem.id !== this.influencerGroupId);
    this.sourceValueList = [];
    if (activeGroup) {
      const thisGroupName = this.translate.instant('new_group_settings.auto_group_sources.this_group');
      const thisGroup = Object.assign({}, activeGroup, {
        name: thisGroupName,
        value: thisGroupName
      });
      this.sourceValueList.push(thisGroup);
    }
    this.sourceValueList = this.sourceValueList.concat(otherGroups);
    this.valueDropdownPlaceholder = this.translate.instant('new_group_settings.auto_group_sources.group_list_placeholder');
    this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.based_on');
  }

  private loadCampaignListAndComparison() {
    if (this.campaignList && this.campaignList.length === 0) {
      this.campaignService.getCampaignFullListForCompany(this.userService.getCompanyId(), false).subscribe(res => {
        this.campaignList = res.campaigns.map(cp => ({
          id: cp.id,
          name: cp.name,
          value: cp.name
        }));
        this.processCampaignListAndComparison();
      });
    } else {
      this.processCampaignListAndComparison();
    }

  }

  private processCampaignListAndComparison() {
    this.sourceValueList = this.campaignList;
    this.showStaticValue = this.sourceValueList.length === 0;
    this.sourceStaticValue = this.sourceValueList.length === 0 ? this.translate.instant('new_group_settings.auto_group_sources.no_available_campaigns') : null;
    this.showValueDropdownList = this.sourceValueList.length !== 0;
    this.valueDropdownPlaceholder = this.translate.instant('new_group_settings.auto_group_sources.campaign_placeholder');
    this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
  }

  get isMultipleSelect() {
    return this.sourceItem.type !== AutoGroupSourceEnum.LOOKALIKE;
  }

  afterDeleteProject(projectId) {
    if (this.selectedProject === projectId) {
      this.selectedProject = null;
    }
    this.userService.getAllProjectOfAdvertiser().subscribe((res) => {
      this.updateProjectList(res.data);
    });
  }

  onEditOrCreateProject(project) {
    if (project.id > 0) {
      project.keywords = project.projectKeywords.map(item => item.keyword);
      project.countries = project.projectCountries.map(item => item.country.id);
      this.eventTracker.trackUserAction(UserActionType.VIEW, Page.PROJECT, {
        id: project.id,
        name: project.name,
        type: 'Project'
      }, undefined, undefined, {
        type: ActivePages.MEASURE
      });
    }
    this.editOrCreateProjectEvent.emit(project);
  }

  deleteGroupSource() {
    this.deleteGroupSourceEvent.emit(this.sourceItem);
  }

  public validateSources(): ErrorTemplate[] {
    this.fieldErrors = [];
    if (!this.sourceItem.type) {
      this.fieldErrors.push(new ValidationError(`influencer_group_type_${this.itemIndex}`, 'Incomplete source'));
    }
    // no validation for branded signup config
    if (this.sourceItem.type === AutoGroupSourceEnum.BRANDED_SIGNUP) {
      return this.fieldErrors;
    }
    if (this.sourceItem.type === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
      if (!this.instagramFollwerValue) {
        this.fieldErrors.push(new ValidationError(`auto_group_instagram_follower_${this.sourceItem.type}`, 'Incomplete source'));
      }
      if (this.instagramFollwerValue && !this.instagramFollwerValue.startsWith('@')) {
        this.fieldErrors.push(new ValidationError(`auto_group_instagram_follower_${this.sourceItem.type}`, 'Missing value'));
      }
    }
    if (this.haveEmptySourcesValue() || this.haveEmptyCampaignSourceValues()) {
      this.noAvailabelCampaign = this.haveEmptyCampaignSourceValues();
      this.fieldErrors.push(new ValidationError(`auto_group_dropdown_value_${this.sourceItem.type}`, 'Incomplete source'));
    }
    if (this.sourceItem.type === AutoGroupSourceEnum.MENTIONS && !this.selectedProject) {
      this.fieldErrors.push(new ValidationError(`auto_group_project_${this.sourceItem.type}`, 'Incomplete source'));
    }
    if (this.fieldErrors.length > 0) {
      this.errorMessage = this.fieldErrors.filter(errorItem => errorItem.message === this.instagramErrorMsg).length > 0 ? this.translate.instant('new_group_settings.missing_value') : this.translate.instant('new_group_settings.not_complete');
    } else {
     this.errorMessage = null;
    }
    return this.fieldErrors;
  }

  /**
   * Check any sources which is not campaign or instagram_follower type has empty value
   */
  private haveEmptySourcesValue() {
    return this.sourceItem.type && this.sourceItem.type !== AutoGroupSourceEnum.CAMPAIGNS
      && this.sourceItem.type !== AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS
      && this.sourceItem.type !== AutoGroupSourceEnum.MENTIONS
      && this.autoGroupSourceValue && this.autoGroupSourceValue.length === 0;
  }

  /**
   * Check any sources which is campaign type has empty value
   */
  private haveEmptyCampaignSourceValues() {
    return this.sourceItem.type && this.sourceItem.type === AutoGroupSourceEnum.CAMPAIGNS && ((this.campaignList.length > 0
      && this.autoGroupSourceValue && this.autoGroupSourceValue.length === 0) || this.campaignList.length === 0);
  }

  private updateProjectList(projectList) {
    if (!projectList || projectList.length === 0 || projectList.filter(item => item.id === 0).length === 0) {
      this.listProject = [{
        id: 0,
        name: this.translate.instant('measure.create_new_project')
      }];
    }

    if (Array.isArray(projectList)) {
      this.listProject = this.listProject.concat(projectList.filter(projectItem => this.listProject.every(item => item.id !== projectItem.id)));
    }
  }

  onFocusOutMentionInput() {
    if (this.instagramFollwerValue && this.instagramFollwerValue.startsWith('@')) {
      const instagramSourceValue = new AutoGroupSourceValue();
      instagramSourceValue.id = null;
      instagramSourceValue.name = this.instagramFollwerValue;
      instagramSourceValue.type = this.sourceItem.type;
      this.sourceItem.sourceValues = [instagramSourceValue];
    }
  }

  closeDropDown(evt) {
    if (this.sourceItem.sourceValues.length > 0) {
      this.validateSources();
    }
  }

  selectValue(evt) {
    if (!evt) {
      this.autoGroupSourceValue = [];
      return;
    }
    this.mappedSourceValues = [];
    if (this.AutoGroupSourceHasSingleValue.indexOf(this.sourceItem.type) >= 0) {
      this.mappedSourceValues = [{
        id: evt.id,
        name: evt.name,
        type: this.sourceItem.type
      }];
    } else {
      this.mappedSourceValues = evt.map(item => ({
        id: item.id,
        name: item.name,
        type: this.sourceItem.type
      }));
    }
    this.sourceItem.sourceValues = this.mappedSourceValues;
  }

  updateSelectedProject(project) {
    this.selectedProject = project.id;
    this.sourceItem.sourceValues = [{
      id: project.id,
      name: project.name,
      type: this.sourceItem.type
    }];
  }

  instagramFollowerInputKeyDown(evt) {
    this.errorMessage = evt.target.value && !evt.target.value.startsWith('@') ? this.translate.instant('new_group_settings.missing_value') : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-source-item/auto-group-source-item.component.ts